"use client";

import { useState } from "react";
import { copyToClipboard } from "../lib/copy";

export interface CodeSample {
  label: string;
  language: string;
  code: string;
}

export function CodeTabs({ samples }: { samples: CodeSample[] }) {
  const [active, setActive] = useState(samples[0]?.label ?? "");
  const [copied, setCopied] = useState(false);

  const current = samples.find((s) => s.label === active) ?? samples[0];

  const copy = async () => {
    if (!current) return;
    const ok = await copyToClipboard(current.code);
    if (ok) {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  if (!current) return null;

  return (
    <div className="not-prose my-6 rounded-lg border border-border bg-surface overflow-hidden">
      <div className="flex items-center justify-between border-b border-border bg-surface-elevated">
        <div className="flex">
          {samples.map((s) => (
            <button
              key={s.label}
              type="button"
              onClick={() => setActive(s.label)}
              className={`px-4 py-2 text-xs font-medium border-r border-border last:border-r-0 transition-colors cursor-pointer ${
                s.label === active
                  ? "text-accent bg-surface"
                  : "text-text-secondary hover:text-text-primary"
              }`}
            >
              {s.label}
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={copy}
          className="px-3 py-2 text-xs text-text-secondary hover:text-accent transition-colors cursor-pointer"
        >
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <pre className="m-0 px-4 py-3.5 overflow-auto text-[13px] leading-6 font-mono text-text-primary whitespace-pre">
        <code>{current.code}</code>
      </pre>
    </div>
  );
}

export function CodeBlock({
  language = "bash",
  children,
  label,
}: {
  language?: string;
  children: string;
  label?: string;
}) {
  return (
    <CodeTabs
      samples={[{ label: label ?? language, language, code: children.trim() }]}
    />
  );
}
